import React from "react"
import OfertouLogo from "../../assets/logo-homepage.svg"
import Footer from "../../components/Footer"

const AboutUs: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#e9e2db] flex flex-col">
      {/* Header - Matched with Home page header but without position sticky */}
      <header className="bg-[#e9e2db] py-5 px-4 sm:px-6 md:px-12 lg:px-24 w-full z-10">
        <div className="flex items-center justify-between max-w-[1400px] mx-auto">
          <a href="/" className="mr-8">
            <img src={OfertouLogo} alt="Ofertou Logo" width={130} height={45} className="h-10 w-auto" />
          </a>
          <nav className="hidden md:flex space-x-12">
            <a href="/app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
              Ofertas
            </a>
            <a
              href="/#como-funciona"
              className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors"
            >
              Como Funciona
            </a>
            <a href="https://espera.ofertou.app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
              Divulgar produtos
            </a>
          </nav>
          <div className="md:hidden flex items-center">
            <button className="p-2 text-[#212121]">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
      </header>

      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-800 mb-8 border-b pb-4">Sobre a Ofertou</h1>

          <div className="space-y-6 text-gray-600">
            <div className="flex justify-center mb-8">
              <img src={OfertouLogo} alt="Ofertou Logo" className="h-16 w-auto" />
            </div>
            
            <p className="leading-relaxed">
              O <span className="text-[#eb6813] font-medium">Ofertou</span> é uma empresa brasileira fundada em 2023, nascida do propósito de transformar o desperdício em oportunidade. Inspirados pela urgência de combater o desperdício global e promover um consumo mais consciente. Assim, nasceu o Ofertou, um aplicativo que conecta comerciantes e consumidores, proporcionando descontos em produtos próximos ao vencimento e contribuindo diretamente para a redução do desperdício de alimentos.
            </p>

            <div className="bg-gray-50 p-5 rounded-md">
              <p className="leading-relaxed">
                Mais do que uma plataforma, o Ofertou é um movimento que fortalece o comércio local, apoia pequenos e médios empreendedores, e promove um consumo mais responsável e sustentável. Nosso compromisso é claro: transformar o desperdício em impacto, garantindo um futuro mais consciente para as próximas gerações.
              </p>
            </div>

            <div className="bg-[#f9f5f1] p-5 rounded-md text-center mt-8">
              <p className="text-lg font-medium">
                Obrigado por fazer parte desta jornada. Junte-se a nós e descubra um mundo de oportunidades.
              </p>
              <a 
                href="/app" 
                className="inline-flex items-center justify-center px-6 py-3 mt-4 border border-transparent text-base font-medium rounded-md text-white bg-[#eb6813] hover:bg-[#d25700] transition-colors"
              >
                Explorar Ofertas
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default AboutUs
